import { render, staticRenderFns } from "./sSelectedSubsector.vue?vue&type=template&id=429149b4"
import script from "./sSelectedSubsector.vue?vue&type=script&lang=js"
export * from "./sSelectedSubsector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports